import React, { useState, useEffect } from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { getCurrentUser, fetchUserAttributes } from '@aws-amplify/auth';

const AdminProtectedRoute = ({ isAuthPage }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);

  useEffect(() => {
    checkAuthState();
  }, []);

  const checkAuthState = async () => {
    try {
      await getCurrentUser();
      const attributes = await fetchUserAttributes();
      const userType = attributes['custom:userType'];
      setIsAuthenticated(userType === 'admin');
    } catch (error) {
      setIsAuthenticated(false);
    }
  };

  if (isAuthenticated === null) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (isAuthPage) {
    return isAuthenticated ? <Navigate to="/dashboard" /> : <Outlet />;
  }

  return isAuthenticated ? <Outlet /> : <Navigate to="/login" />;
};

export default AdminProtectedRoute;